import type { PropsWithChildren, ReactNode } from 'react'

import InfoIcon from '@/assets/icons/icon-info.svg'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { classNames } from '@/utils/helpers'

interface Props extends PropsWithChildren {
  title: ReactNode
  description: ReactNode
  mobileVertical?: boolean
  disableTopPadding?: boolean
  disableBottomPadding?: boolean
  biggerTitle?: boolean
  error?: string
  caption?: string
}

export const SettingsOption = (props: Props) => {
  const {
    title,
    description,
    children,
    mobileVertical,
    disableTopPadding,
    disableBottomPadding,
    biggerTitle,
    error,
    caption,
  } = props

  return (
    <div
      className={classNames(
        'grid items-center justify-between py-8 md:grid-flow-col md:grid-cols-3',
        mobileVertical ? 'grid-flow-row gap-4' : 'grid-flow-col grid-cols-3',
        disableTopPadding && 'pt-0',
        disableBottomPadding && 'pb-0',
      )}
    >
      <div className="col-span-2 grid gap-1">
        <div
          className={classNames(
            'text-title font-medium',
            biggerTitle && 'text-xl font-semibold',
          )}
        >
          {title}
        </div>
        <p className="flex gap-2 text-text-sub text-sm">
          {description}
          {caption && (
            <Tooltip content={caption}>
              <InfoIcon className="text-secondary-300" />
            </Tooltip>
          )}
        </p>

        {error && (
          <p className="text-danger-default whitespace-pre text-sm">{error}</p>
        )}
      </div>
      <div className="col-span-1 justify-self-end">{children}</div>
    </div>
  )
}
